module.exports = __webpack_public_path__ + "86d0a329f0a5d6d64bdf8299b5097cd9.svg";